import React from "react";
import PlaywrightTemplate from "./PlaywrightTemplate";
import styles from "../../styles/Webtable.module.css";

const PwWebTable = () => {
  // persist checked state across refresh
  const STORAGE_KEY = 'pw-webtable-checked';
  const [checkedRows, setCheckedRows] = React.useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : { 0: false };
    } catch {
      return { 0: false };
    }
  });

  React.useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(checkedRows));
  }, [checkedRows]);

  const toggleRow = (index) => () => {
    setCheckedRows(prev => ({ ...prev, [index]: !prev[index] }));
  };

  const rows = [
    { name: 'John', age: 25, email: 'john@test.com' },
    { name: 'Doe', age: 23, email: 'Doe@test.com' },
  ];

  const sections = [
    {
      ui: (
        <div className={`table-responsive ${styles.tableWrapper}`}>            
          <table className={`table table-bordered table-hover ${styles.table}`}>  
            <thead>
              <tr>
                <th>Name</th>
                <th>Age</th>
                <th>Email</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, idx) => (
                <tr key={idx}>
                  <td>{r.name}</td>
                  <td>{r.age}</td>
                  <td>{r.email}</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={checkedRows[idx] || false}
                      onChange={toggleRow(idx)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ),
      code: `// Get row count
const rows = await page.locator('table tbody tr');
console.log(await rows.count());

// Get cell text
const text = await page.locator('table tbody tr td').nth(0).textContent();

// Click checkbox in specific row (0-based index example)
await page.check('table tbody tr:nth-child(1) input[type="checkbox"]');`
    }
  ];

  return <PlaywrightTemplate title="WEB TABLE" sections={sections} />;
};

export default PwWebTable;